import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AppContext from "../../container/context";
import serverHost from "../../services/serverHost";
import api from "../../services/api";
import Form from "../../components/form";

import {
  Grid,
  Button,
  ListItemText,
  Box,
  CircularProgress,
} from "@mui/material";
import EscolasExclusividade from "./EscolasExclusividade";

export default function Material(props) {
  const [carregando, setCarregando] = useState(false);
  const [materialId] = useState(Number(props.match.params.id));
  const { notification } = useContext(AppContext);
  const history = useHistory();
  const [produtoSelecionado, setProdutoSelecionado] = useState(false);
  const [comboCiclo, setComboCiclo] = useState([]);
  const [comboNivel, setComboNivel] = useState([]);
  const [comboCategoria, setComboCategoria] = useState([]);
  const [comboSubCategoria, setComboSubCategoria] = useState([]);
  const [dadosSalvar, setDadosSalvar] = useState({
    categoriaId: 0,
    subcategoriaId: 0,
    nome: "",
    ordem: 0,
    produto: 0,
    cicloId: 0,
    nivelId: 0,
    arquivo: "",
    inativacao: "",
  });

  useEffect(() => {
    if (materialId > 0) carregarMaterial();
  }, []);

  const carregarMaterial = () => {
    api
      .get("materiais/carregar", { id: materialId })
      .then((material) => {
        if (material.cicloId > 0) {
          material.produto = 1;
          carregarComboCiclo();
        }

        if (material.nivelId > 0) {
          material.produto = 2;
          carregarComboNivel();
        }
        let materialSalvar = dadosSalvar;
        materialSalvar.categoriaId = material.categoriaId;
        materialSalvar.cicloId = material.cicloId;
        materialSalvar.subcategoriaId = material.subcategoriaId;
        materialSalvar.nome = material.nome;
        materialSalvar.ordem = material.ordem;
        materialSalvar.produto = material.produto;
        materialSalvar.nivelId = material.nivelId;
        materialSalvar.formato = material.formato;
        materialSalvar.caminhoArquivo = material.caminhoArquivo;
        if (material.inativacao)
          materialSalvar.inativacao = material.inativacao.split(" ")[0];
        setDadosSalvar(materialSalvar);
        setProdutoSelecionado(true);
        carregarComboCategorias(material.produto);
        carregarComboSubcategoria(material.categoriaId);
      })
      .catch((e) =>
        notification("error", "Não foi possível carregar o material")
      );
  };

  const selecionarProduto = (paramsProduto) => {
    const produtoSelecionado = dadosSalvar;
    produtoSelecionado.produto = paramsProduto.produto;
    // const material = { ...this.state.material };

    // material.produto = produtoSelecionado;

    setDadosSalvar(produtoSelecionado);
    // setDados(produto);
    setProdutoSelecionado(true);
    // carregarComboCiclo();
    carregarComboCategorias(paramsProduto.produto);
    switch (paramsProduto.produto) {
      case 1:
        return carregarComboCiclo();
      case 2:
        return carregarComboNivel();
      default:
        return;
    }
  };

  const fDados = {
    title: "Produto",
    form: {
      produto: {
        label: "Produto",
        type: "select",
        emptyItem: true,
        emptyItemText: "(Todos)",
        // space: 6,
        options: [
          {
            value: 1,
            desc: "Bilíngue",
          },
          {
            value: 2,
            desc: "Uni Dune Tê",
          },
        ],
        // value: dados.produto,
        value: dadosSalvar.produto,
      },
    },

    submit: {
      label: "Salvar",
      action: selecionarProduto,
      auto: true,
    },
    // close: {
    //   label: "Fechar",
    //   action: () => history.push("/app/material"),
    // },
  };

  const listarMateriais = (fMaterial) => {
    setDadosSalvar(fMaterial);

    if (fMaterial.categoriaId) {
      carregarComboSubcategoria(fMaterial.categoriaId);
    }

    switch (fMaterial.produto) {
      case 1:
        return carregarComboCiclo();
      case 2:
        return carregarComboNivel();
      default:
        return;
    }
  };

  const salvar = (fArquivo) => {
    const materialSalvar = new FormData();

    materialSalvar.append("nome", dadosSalvar.nome);
    materialSalvar.append("ordem", dadosSalvar.ordem);
    materialSalvar.append("cicloId", dadosSalvar.cicloId);
    materialSalvar.append("nivelId", dadosSalvar.nivelId);
    materialSalvar.append("categoriaId", dadosSalvar.categoriaId);
    materialSalvar.append("subcategoriaId", dadosSalvar.subcategoriaId);
    materialSalvar.append("inativacao", dadosSalvar.inativacao);

    if (fArquivo.arquivo && fArquivo.arquivo.length > 0) {
      materialSalvar.append("arquivo", fArquivo.arquivo[0]);
    }

    setCarregando(true);
    // console.log([...materialSalvar]);
    if (materialId > 0) {
      materialSalvar.append("id", materialId);

      api
        .post("materiais/editar", materialSalvar)
        .then((res) => {
          if (res.id) {
            notification("success", "Material salvo!");

            history.goBack();
          } else {
            notification(
              "warning",
              "Não foi possível salvar o material. Verifique as informações."
            );
            setCarregando(false);
          }
        })
        .catch((err) => {
          setCarregando(false);

          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "Material inválido");
            default:
              return notification("error", "Erro ao editar o material");
          }
        });
    } else {
      api
        .put("materiais/inserir", materialSalvar)
        .then((res) => {
          if (res.id > 0) {
            notification("success", "Material salvo!");
            history.goBack();
          } else {
            notification(
              "warning",
              "Não foi possível salvar o material. Verifique as informações."
            );
            setCarregando(false);
          }
        })
        .catch((err) => {
          const { data } = err;
          setCarregando(false);

          switch (data[0]) {
            case 1:
              return notification("error", "Arquivo inválido");
            case 2:
              return notification("error", "Nome inválido");
            case 3:
              return notification("error", "Produto inválido");
            case 4:
              return notification("error", "Ciclo inválido");
            case 5:
              return notification("error", "Nível UDT inválido");
            default:
              return notification("error", "Erro ao salvar o material");
          }
        });
    }
  };

  const montarForm = () => {
    const campos = {
      produto: {
        label: "Produto Perto",
        type: "select",
        emptyItem: true,
        emptyItemText: "(Todos)",
        options: [
          {
            value: 1,
            desc: "Bilíngue",
          },
          {
            value: 2,
            desc: "Uni Dune Tê",
          },
        ],
        value: dadosSalvar.produto,
      },
    };

    if (dadosSalvar.produto === 1) {
      campos.cicloId = {
        label: "Ciclo",
        type: "select",
        emptyItem: true,
        space: 4,
        array: {
          data: comboCiclo,
          value: "id",
          desc: "nome",
        },
        value: dadosSalvar.cicloId,
      };
    }

    if (dadosSalvar.produto === 2) {
      campos.nivelId = {
        label: "Nível",
        type: "select",
        emptyItem: true,
        space: 4,
        array: {
          data: comboNivel,
          value: "id",
          desc: "nome",
        },
        value: dadosSalvar.nivelId,
      };
    }

    // if (!material.produto) return campos;

    campos.categoriaId = {
      label: "Categoria",
      type: "select",
      emptyItem: true,
      space: 4,
      array: {
        data: comboCategoria,
        value: "id",
        desc: "nome",
      },
      value: dadosSalvar.categoriaId,
    };

    campos.subcategoriaId = {
      label: "Subcategoria",
      type: "select",
      emptyItem: true,
      space: 4,
      array: {
        data: comboSubCategoria,
        value: "id",
        desc: "nome",
      },
      value: dadosSalvar.subcategoriaId,
    };

    campos.nome = {
      label: "Nome",
      type: "text",
      space: 4,
      value: dadosSalvar.nome,
    };

    campos.ordem = {
      label: "Ordem",
      type: "number",
      space: 4,
      value: dadosSalvar.ordem,
    };

    campos.inativacao = {
      label: "Data de inativação",
      type: "date",
      space: 4,
      value: dadosSalvar.inativacao,
    };

    return campos;
  };

  const fdadosCadastro = {
    title: materialId === 0 ? "Novo Material" : "Dados do Material",
    form: montarForm(),    
    submit: {
      label: "Salvar",
      action: listarMateriais,
      auto: true,
    },
  };

  const carregarComboCiclo = () => {
    api
      .get("ciclos/listar")
      .then((comboCiclo) => {
        setComboCiclo(comboCiclo);
      })
      .catch((e) => notification("error", "Não foi possível listar os ciclos"));
  };

  const carregarComboNivel = () => {
    api
      .get("udt/listarNiveis")
      .then((comboNivel) => {
        setComboNivel(comboNivel);
      })
      .catch((e) => notification("error", "Não foi possível listar os níveis"));
  };

  const carregarComboCategorias = (produto) => {
    api
      .get("materiais/categorias/listar", { produto: produto.produto })
      .then((comboCategoria) => {
        setComboCategoria(comboCategoria);
      })
      .catch((e) =>
        notification("error", "Não foi possível listar as categorias")
      );
  };

  const carregarComboSubcategoria = (categoriaId) => {
    api
      .get("materiais/categorias/listarSubcategorias", {
        categoriaId: categoriaId,
      })
      .then((comboSubcategoria) => setComboSubCategoria(comboSubcategoria))
      .catch((e) => notification("Não foi possível listar as subcategorias"));
  };

  const montarFormArquivo = () => {
    const campos = {};
    if (materialId > 0) {
      campos.fileDowload = {
        label: "component",
        type: "component",
        space: 6,
        value: (
          <Grid container>
            <Grid item xs={6}>
              <ListItemText
                primary="Tipo do arquivo salvo"
                secondary={dadosSalvar.formato}
              />
            </Grid>
          </Grid>
        ),
      };
    }
    campos.arquivo = {
      label: materialId > 0 ? "Alterar arquivo" : "Arquivo",
      type: "file",
      space: 6,
    };

    return campos;
  };

  const fArquivo = {
    form: montarFormArquivo(),
    submit: {
      label: "Salvar",
      action: salvar,
    },
    close: true,
    history,
    customActions: materialId > 0 ? [{
      label: 'Consultar arquivo',
      action: () => {
        window.open(
          `${serverHost()}/${dadosSalvar.caminhoArquivo}`,
          "_blank"
        );
      }
    }] : undefined
  };

  return (
    <div>
      {!carregando ? (
        <>
          {!produtoSelecionado ? (
            <Form formData={fDados} />          
          ) : (
            <>
              <Form formData={fdadosCadastro} />
              <Form formData={fArquivo} uncontrollable />
              <EscolasExclusividade materialId={materialId} />
            </>
          )}
        </>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      )}
    </div>
  );
}

// const styles = {
//   btnCancel: {
//     color: "white",
//     marginLeft: 10,
//     backgroundColor: "#929699",
//   },
// };
